import { GetterTree } from "vuex";
import { ForexApprovalState } from "./interface";
import { IStoreRootState } from "@/store/interface";
import { ForexApprovalGetter } from "@/feature/Forex/store/approval/constants";
import { ForexOperationType } from "@/feature/Forex/api/forex.interface";
import { PaymentOrderType } from "@/feature/Forex/api/approval/forex-approval.interface";

export default <GetterTree<ForexApprovalState, IStoreRootState>> {

	[ForexApprovalGetter.list]: ({ list }) => list,

	[ForexApprovalGetter.loading]: ({ loadingCount }) => loadingCount !== 0,

	[ForexApprovalGetter.operationType]: ({ operationType }) => operationType,

	[ForexApprovalGetter.toApprovalCount]: ({ toApprovalCount }) => toApprovalCount,

	[ForexApprovalGetter.paymentOrderCount]: ({ paymentOrderCount }) => paymentOrderCount,

	[ForexApprovalGetter.allCount]: ({
		paymentOrderCount,
		toApprovalCount,
	}) => toApprovalCount[ForexOperationType.ALL] +
		paymentOrderCount[PaymentOrderType.SWIFT] +
		paymentOrderCount[PaymentOrderType.UZS],

}